import { render } from "./MenuContentItemValueCombobox.vue?vue&type=template&id=46948602"
import script from "./MenuContentItemValueCombobox.vue?vue&type=script&lang=js"
export * from "./MenuContentItemValueCombobox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__